import _ from 'lodash';
import { Swipe, log } from '@swiper/core';
import { Service } from './Service';
import { generateId } from '../utils';

export class SwipesService extends Service {

  get name() { return 'swipes'; }

  async handleByCard( swipe, data, params ) {
    _.assign( swipe, { card : data.card } );
    swipe.eventlog( {
      event : 'card.swiped',
      card  : { number : swipe.card },
    } );
    const card = await this.getCard( swipe.card );
    if ( ! card ) swipe.bad( 'Invalid Pass' );
    // TODO - Other possible status responses for cards: // lost/stolen
    swipe.eventlog( { card : { status : card.status || 'active' } } );

    const memberId = card.memberId
      || swipe.bad( 'No memberId for card' );
    const membershipId = card.membershipId
      || swipe.bad( 'No membershipId for card' );
    _.assign( swipe, {
      memberId,
      membershipId,
      ident : _.pick( swipe, 'memberId', 'card' ),
    } );
    swipe.eventlog( { memberId, membershipId } );
  }

  async handleByPasslessSignin( swipe, data, params ) {
    swipe.eventlog( { event : 'passless-signin' } );
    // TODO
  }

  async create( data, params ) {
    log.debug( 'CREATING SWIPE', data );
    const swipe = new Swipe( {
      id        : generateId( 'swipe' ),
      stationId : params.station.id,
    } );
    params.eventlog = { swipeId : swipe.id };
    const eventlog = _.partial( _.merge, params.eventlog );
    const bad = ( msg ) => this.throw( 'GeneralError', msg );
    Object.defineProperty( swipe, 'eventlog', { value : eventlog } );
    Object.defineProperty( swipe, 'bad', { value : bad } );

    try {
      if ( data.handler ) {
        await this.handleByPasslessSignIn( swipe, data, params );
      } else {
        await this.handleByCard( swipe, data, params );
      }

      const { membershipId } = swipe;
      if ( ! membershipId ) bad( 'No membershipId' );
      eventlog( { membershipId } );

      const sessions = this.app.service( 'sessions' );
      const session = await sessions.create( { membershipId } );

      if ( ! session ) bad( `Unable to create session` );
      swipe.session = session;
      eventlog( { sessionId : session.id } );

      if ( ! session.membership ) {
        bad( `Membership ${membershipId} not found` );
      }
      const { memberId } = swipe;
      if ( memberId ) {
        eventlog( { memberId } );
        const member = session.getMember( memberId );
        if ( ! member ) bad( `Member ${memberId} not found` );

        // Toggle the status of whoever just swiped, unless they have set
        // a configuration flag indicating that should not happen..
        if ( member.setting( 'toggleOnSwipe' ) ) {
          swipe.session = await sessions.patch( session.id, {
            event           : member.present ? 'member-out' : 'member-in',
            memberId        : member.id,
            membershipId    : swipe.membershipId,
            sessionId       : session.id,
            ident           : swipe.ident,
          } );
          eventlog( { toggled : true } );
        }
      }
      return swipe;
    } catch( error ) {
      swipe.valid = false;
      swipe.error = error.message;
      eventlog( { error : error.message } );
    }
    return swipe;
  }

  async getCard( card ) {
    return this.app.service( 'cards' ).get( card ).catch( _.noop );
  }

}

export const hooks = {
  before  : { all : [ 'auth' ] },
  after   : { create : [ 'eventlog' ] },
};
